import { AbstractValueObject } from './abstractValueObject';

/**
 * ValueObjectProps
 */
export interface ValueObjectProps {
  [index: string]: any;
}

/**
 * 複数項目のあるValueObject.
 * @param T T
 */
export abstract class ValueObject<T extends ValueObjectProps> extends AbstractValueObject<T> { }
